import React, { useEffect } from 'react'
import Header from './components/header/Header'
import Nav from './components/nav/Nav'
import About from './components/about/About'
import Experience from './components/experience/Experience'
import Portfolio from './components/portfolio/Portfolio'
import Testimonials from './components/testimonials/Testimonials'
import Contact from './components/contact/Contact'
import Footer from './components/footer/Footer'

// Import AOS library and styles
import AOS from 'aos'
import 'aos/dist/aos.css'

const App = () => {
  // Initialize AOS with a slight delay
  useEffect(() => {
    const timer = setTimeout(() => {
      AOS.init({
        duration: 1000,
        once: true,
        offset: 50,
      });
    }, 100); // 100ms delay

    // Cleanup the timer if the component unmounts before it fires
    return () => clearTimeout(timer);
  }, []);

  return (
   <>
        <Header />
        <Nav />
        <About/>
        <Experience/>
        <Portfolio/>
        <Testimonials/>
        <Contact/>
        <Footer/>
   </>
  )
}

export default App